
import { Link } from 'react-router-dom';
import Navigation from '../../home/components/Navigation';
import Footer from '../../home/components/Footer';

const ConciergeAiPage = () => {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact-section');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F8F4EF' }}>
      <Navigation />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h1 
            className="text-5xl lg:text-6xl font-bold mb-6"
            style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}
          >
            NextPhase Concierge AI™
          </h1>
          <p 
            className="text-2xl mb-10"
            style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}
          >
            Your organization's AI assistant trained on your workflows, language, and internal processes.
          </p>
          <button
            onClick={scrollToContact}
            className="inline-flex items-center px-8 py-4 rounded-lg font-semibold text-white text-lg transition-all duration-300 hover:shadow-lg whitespace-nowrap cursor-pointer"
            style={{ backgroundColor: '#7B6655' }}
          >
            Schedule Workflow Audit
            <i className="ri-calendar-line ml-2"></i>
          </button>
        </div>
      </section>

      {/* Content Sections */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          
          {/* Who This Is For */}
          <div className="mb-16">
            <h2 
              className="text-3xl font-bold mb-8"
              style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}
            >
              Who This Is For
            </h2>
            <div className="space-y-4">
              <div className="flex items-start">
                <i className="ri-check-line text-2xl mr-4 mt-1" style={{ color: '#7B6655' }}></i>
                <p className="text-lg" style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}>
                  Organizations with repetitive staff questions or client requests
                </p>
              </div>
              <div className="flex items-start">
                <i className="ri-check-line text-2xl mr-4 mt-1" style={{ color: '#7B6655' }}></i>
                <p className="text-lg" style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}>
                  Teams that need internal knowledge centralized and easily accessible
                </p>
              </div>
              <div className="flex items-start">
                <i className="ri-check-line text-2xl mr-4 mt-1" style={{ color: '#7B6655' }}></i>
                <p className="text-lg" style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}>
                  Leaders wanting to reduce support load and response time
                </p>
              </div>
            </div>
          </div>

          {/* What's Included */}
          <div className="mb-16">
            <h2 
              className="text-3xl font-bold mb-8"
              style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}
            >
              What's Included
            </h2>
            <div className="space-y-4">
              <div className="flex items-start">
                <i className="ri-arrow-right-line text-2xl mr-4 mt-1" style={{ color: '#7B6655' }}></i>
                <p className="text-lg" style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}>
                  AI knowledge base training
                </p>
              </div>
              <div className="flex items-start">
                <i className="ri-arrow-right-line text-2xl mr-4 mt-1" style={{ color: '#7B6655' }}></i>
                <p className="text-lg" style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}>
                  Workflow execution prompts
                </p>
              </div>
              <div className="flex items-start">
                <i className="ri-arrow-right-line text-2xl mr-4 mt-1" style={{ color: '#7B6655' }}></i>
                <p className="text-lg" style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}>
                  Internal request routing automation
                </p>
              </div>
              <div className="flex items-start">
                <i className="ri-arrow-right-line text-2xl mr-4 mt-1" style={{ color: '#7B6655' }}></i>
                <p className="text-lg" style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}>
                  Custom voice tone and organizational vocabulary matching
                </p>
              </div>
            </div>
          </div>

          {/* Key Outcomes */}
          <div className="mb-16">
            <h2 
              className="text-3xl font-bold mb-8"
              style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}
            >
              Key Outcomes / Benefits
            </h2>
            <div className="space-y-4">
              <div className="flex items-start">
                <i className="ri-star-line text-2xl mr-4 mt-1" style={{ color: '#7B6655' }}></i>
                <p className="text-lg" style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}>
                  Faster response times
                </p>
              </div>
              <div className="flex items-start">
                <i className="ri-star-line text-2xl mr-4 mt-1" style={{ color: '#7B6655' }}></i>
                <p className="text-lg" style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}>
                  Lower administrative burden on staff
                </p>
              </div>
              <div className="flex items-start">
                <i className="ri-star-line text-2xl mr-4 mt-1" style={{ color: '#7B6655' }}></i>
                <p className="text-lg" style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}>
                  Consistent, accurate information delivery
                </p>
              </div>
            </div>
          </div>

          {/* Timeline & Pricing */}
          <div className="grid md:grid-cols-2 gap-12 mb-16">
            <div>
              <h2 
                className="text-3xl font-bold mb-6"
                style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}
              >
                Timeline
              </h2>
              <p className="text-2xl font-semibold" style={{ color: '#7B6655', fontFamily: 'Inter, sans-serif' }}>
                4–8 weeks
              </p>
            </div>
            <div>
              <h2 
                className="text-3xl font-bold mb-6"
                style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}
              >
                Typical Pricing Range
              </h2>
              <p className="text-2xl font-semibold" style={{ color: '#7B6655', fontFamily: 'Inter, sans-serif' }}>
                $5,000–$12,000
              </p>
            </div>
          </div>

          {/* CTA Section */}
          <div id="contact-section" className="text-center bg-white p-12 rounded-2xl shadow-sm border" style={{ borderColor: '#E6DACD' }}>
            <h2 
              className="text-3xl font-bold mb-6"
              style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}
            >
              Ready for Your AI Assistant?
            </h2>
            <p 
              className="text-xl mb-8 max-w-2xl mx-auto"
              style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}
            >
              Schedule a free workflow audit to explore how NextPhase Concierge AI™ can support your team and clients.
            </p>
            <button
              className="inline-flex items-center px-8 py-4 rounded-lg font-semibold text-white text-lg transition-all duration-300 hover:shadow-lg whitespace-nowrap cursor-pointer"
              style={{ backgroundColor: '#7B6655' }}
            >
              Schedule Your Free Workflow Audit
              <i className="ri-calendar-line ml-2"></i>
            </button>
            
            {/* Cross-link to How We Work */}
            <div className="mt-8 pt-6 border-t" style={{ borderColor: '#E6DACD' }}>
              <p className="text-base" style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}>
                Want our full implementation framework? 
                <Link 
                  to="/services/how-we-work" 
                  className="ml-1 font-medium transition-colors duration-200 cursor-pointer hover:opacity-80"
                  style={{ color: '#7B6655' }}
                >
                  See How We Work →
                </Link>
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ConciergeAiPage;
